<template>
  <div>
    <b-form @submit.prevent="submit" novalidate>

      <div class="row">
        <div class="col-12 mb-2">
          <auto-complete :get-data="loadClients" :result="clientSelected" :item-text="itemText" placeholder="Sisesta nimi või kood..."/>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <div class="data-list">
            <dl>
              <dt>Tolliviide</dt>
              <dd>{{declaration.customsReference}}</dd>
            </dl>
          </div>
        </div>
        <div class="col">
          <div class="data-list">
            <dl>
              <dt>Viitenumber</dt>
              <dd>{{declaration.reference}}</dd>
            </dl>
          </div>
        </div>
        <div class="col">
          <div class="data-list">
            <dl>
              <dt>Valitud klient</dt>
              <dd v-if="client">{{client.name}}</dd>
              <dd v-if="!client">-</dd>
            </dl>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <submit-button class="float-right" variant="primary" :disabled="!client">Kinnita kliendi määramine</submit-button>
        </div>
      </div>
    </b-form>
  </div>
</template>

<script>
  import gateway from '@/services/gateway'
  import AutoComplete from '@/components/AutoComplete'

  export default {
    props: ['declaration'],
    components: {AutoComplete},
    data() {
      return {
        client: null
      }
    },
    methods: {
      loadClients(query) {
        return gateway.get('/clients?query=' + query).then(r => r.data)
      },
      clientSelected(client) {
        this.client = client
      },
      itemText(client) {
        return client.name
      },
      submit() {
        gateway
          .post(`/declarations/${this.declaration.id}/set-client`, {clientId: this.client.id})
          .then(() => {
            this.$notifications.info(`Deklaratsiooni klient on määratud. Uus klient on ${this.client.name}`)
            this.$emit('done')
          })
      }
    }
  }
</script>
